import moment from 'moment';
/**
 * Check if given value matches any of the defined allowed formats
 * Returns the date if its valid, undefined if not
 * @param  {String|Date|...}  value
 * @param  {Array}  formats
 * @return {Moment|undefined}
 */

export default function isValidDate(value, formats) {
  if (!value) {
    return;
  }

  var date = moment(value, formats, // force strict mode, otherwise any integer is a valid date
  // https://momentjs.com/guides/#/parsing/strict-mode/
  true);

  if (date.isValid()) {
    return moment.isMoment(value) ? value : date;
  }
}